import { makeAction } from "async-action-creator";
import { notification } from "antd";

import i18n from "../../i18n";
import api from "../../utils/api";
import { createApiThunk } from "../../utils/thunk";

export const FETCH_HEADQUARTER = makeAction("headquarter/FETCH_HEADQUARTER");

export const UPDATE_HEADQUARTER_PROFILE = makeAction(
  "headquarter/UPDATE_HEADQUARTER_PROFILE"
);

export const UPDATE_ALL_COMPANIES_PROFILES = makeAction(
  "company/UPDATE_ALL_COMPANIES_PROFILES"
);

export const fetchHeadquarter = createApiThunk({
  action: FETCH_HEADQUARTER,
  request: async id => {
    if (!id) {
      throw new Error("Headquarter id is required");
    }

    const profile = await api.company.fetch(id);
    const users = await api.company.getUsers(id);

    return {
      ...profile,
      users
    };
  }
});

export const updateHeadquarterProfile = createApiThunk({
  action: UPDATE_HEADQUARTER_PROFILE,
  request: ({ companyId, formData }) => {
    const companyData = api.company.update({
      ...formData,
      id: companyId
    });

    return companyData;
  },
  onResolved: () =>
    notification.success({
      message: i18n.t("global:good"),
      description: i18n.t("toasts:company.updateProfileResolved")
    }),
  onRejected: () =>
    notification.error({
      message: i18n.t("global:error"),
      description: i18n.t("toasts:company.updateProfileRejected")
    })
});

export const updateAllCompaniesProfiles = createApiThunk({
  action: UPDATE_ALL_COMPANIES_PROFILES,
  request: async ({ company, siteConfig }, { companies }) => {
    if (!company || !company.id) {
      throw new Error("Company id is required");
    }

    const companyList =
      companies || (await api.headquarter.company.list.fetch(company.id));

    const [updatedSupercompany] = await Promise.all([
      api.company.update({ id: company.id, siteConfig }),
      ...companyList.map(company =>
        api.company.update({ id: company.id, siteConfig })
      )
    ]);

    return updatedSupercompany;
  },
  onResolved: () =>
    notification.success({
      message: i18n.t("global:good"),
      description: i18n.t("toasts:company.updateProfilesResolved")
    }),
  onRejected: () =>
    notification.error({
      message: i18n.t("global:error"),
      description: i18n.t("toasts:company.updateProfilesRejected")
    })
});
